import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		width: "24px",
		height: "24px",
		marginTop: "8px",
		fill: theme.palette.colors.purplishBlue,
	},
	isGrey: {
		marginTop: 0,
		fill: theme.palette.colors.cloudyBlue,
		"& $path": {
			fill: theme.palette.colors.cloudyBlue,
		},
	},
	path: {
		fill: theme.palette.colors.purplishBlue,
	},
});

export class BaseSVG extends React.Component {
	static defaultProps = {
		width: 24,
		height: 24,
		marginTop: 0,
	};

	static propTypes = {
		color: PropTypes.string,
		width: PropTypes.number,
		height: PropTypes.number,
		marginTop: PropTypes.number,
	};

	render() {
		let classes = this.props.classes;
		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={this.props.width}
				height={this.props.height}
				viewBox={`0 0 ${this.props.width} ${this.props.height}`}
				className={classNames(classes.root, {
					[classes.isGrey]: this.props.grey,
				})}
			>
				{React.Children.map(this.props.children, (item) => {
					return React.cloneElement(item, {
						className: classes.path,
					});
				})}
			</svg>
		);
	}
}

export default withStyles(styles)(BaseSVG);
